/**
 * Action types for Alarm Configation functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_GENERAL_CONFIG = 'GET_GENERAL_CONFIG';
export const GET_GENERAL_CONFIG_SUCCESS = 'GET_GENERAL_CONFIG_SUCCESS';
export const GET_GENERAL_CONFIG_FAIL = 'GET_GENERAL_CONFIG_FAIL';
export const EDIT_GENERAL_CONFIG = 'EDIT_GENERAL_CONFIG'
export const EDIT_GENERAL_CONFIG_COMPLETE =  'EDIT_GENERAL_CONFIG_COMPLETE'